var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.00019 6.5H15.8002L10.7002 1.4C10.5002 1.2 10.5002 0.900003 10.7002 0.700003C10.9002 0.500003 11.2002 0.500003 11.4002 0.700003L17.4002 6.7C17.4002 6.7 17.5002 6.8 17.5002 6.9C17.6002 7 17.6002 7.2 17.5002 7.3C17.5002 7.4 17.4002 7.4 17.4002 7.5L11.4002 13.5C11.3002 13.6 11.2002 13.6 11.0002 13.6C10.8002 13.6 10.7002 13.6 10.6002 13.5C10.4002 13.3 10.4002 13 10.6002 12.8L15.7002 7.7H1.00019C0.700195 7.7 0.500195 7.5 0.500195 7.2C0.500195 6.9 0.700195 6.5 1.00019 6.5Z"}));
}

ArrowRight.defaultProps = {"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
